import React from "react";
import NavContainer from "../components/NavContainer/navContainer";
import MainGrid from "../components/MainGrid/mainGrid";

function Home() {
  return (
    <div className="App">
      <NavContainer />
      <MainGrid />
    </div>
  );
}

export default Home;
